/**
 * Stores recent search terms in localStorage for the Sana search modal.
 */
export class RecentSearches {
  /** @static @constant {string} */
  static #STORAGE_KEY = 'recentSearchTerms';
  /** @static @constant {string} */
  static #DISABLED_KEY = 'recentSearchTermsDisabled';
  /** @static @constant {number} */
  static #MAX_SEARCHES = 5;

  /**
   * @param {string} term
   */
  static add(term) {
    if (!this.isEnabled()) return;

    const normalized = term.trim();
    if (!normalized) return;

    let searches = this.getSearches();
    searches = searches.filter((item) => item.toLowerCase() !== normalized.toLowerCase());
    searches.unshift(normalized);
    searches = searches.slice(0, this.#MAX_SEARCHES);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(searches));
  }

  /**
   * @param {string} term
   */
  static remove(term) {
    const searches = this.getSearches().filter((item) => item !== term);
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(searches));
  }

  static clear() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  static deactivate() {
    this.clear();
    localStorage.setItem(this.#DISABLED_KEY, 'true');
  }

  static activate() {
    localStorage.removeItem(this.#DISABLED_KEY);
  }

  /**
   * @returns {boolean}
   */
  static isEnabled() {
    return localStorage.getItem(this.#DISABLED_KEY) !== 'true';
  }

  /**
   * @returns {string[]}
   */
  static getSearches() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
